import React from 'react'

export default function LockIcon({ width = 15, height = 20, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.75 8.75H12.5V5C12.5 2.25 10.25 0 7.5 0C4.75 0 2.5 2.25 2.5 5V8.75H1.25C0.625 8.75 0 9.375 0 10V18.75C0 19.375 0.625 20 1.25 20H13.75C14.375 20 15 19.375 15 18.75V10C15 9.375 14.375 8.75 13.75 8.75ZM8.75 17.5H6.25L6.75 14.75C6.125 14.5 5.625 13.75 5.625 13.125C5.625 12.125 6.5 11.25 7.5 11.25C8.5 11.25 9.375 12.125 9.375 13.125C9.375 13.875 9 14.5 8.25 14.75L8.75 17.5ZM10 8.75H5V5C5 3.625 6.125 2.5 7.5 2.5C8.875 2.5 10 3.625 10 5V8.75Z" fill="#5A6173"/>
    </svg>
  )
}
